import format from '@/plugins/baseFormat';
import Store from '@/models/Store';
import Driver from '@/models/Driver';
import VueX from '@/store';

export default class LogisticOperator {
  constructor (initialData = {},) {
    const {
      _id,
      name,
      address,
      published,
      corporate_name,
      cnpj,
      inscricao_estadual,
      inscricao_municipal,
      tax_regime,
      responsible,
      phone,
      stores,
      drivers,
      attachments,
    } = initialData;

    this._id = _id;
    this.name = name;
    this.address = address;
    this.published = published;
    this.address = address;
    this.corporate_name = corporate_name;
    this.cnpj = cnpj;
    this.inscricao_estadual = inscricao_estadual;
    this.inscricao_municipal = inscricao_municipal;
    this.tax_regime = tax_regime;
    this.responsible = responsible;
    this.phone = phone;
    this.stores = stores;
    if (this.stores)
    {this.stores.items =
        stores && stores.items && stores.items.length
          ? stores.items.map((store,) => new Store(store,),)
          : [];}
    this.drivers = drivers;
    if (this.drivers)
    {this.drivers.items =
        drivers && drivers.items && drivers.items.length
          ? drivers.items.map((driver,) => new Driver(driver,),)
          : [];}
    this.attachments = (attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
          attachment.status === 'APPROVED'
            ? 'Aprovado'
            : attachment.status === 'DISAPPROVED'
              ? 'Reprovado'
              : 'Pendente',
        name: `${attachment.attachment_type.split('_',)[0]}.${attachment.key.split('.',)[1]}`,
      };
    },);
  }

  get formatted_city_state () {
    return format.city_state({ city: this.address.city, state: this.address.state, },);
  }

  get formatted_phone () {
    return format.phone(this.phone,);
  }

  get formatted_cnpj () {
    return format.cnpj(this.cnpj,);
  }

  get formatted_responsible_phone () {
    return format.phone((this.responsible || {}).phone,);
  }

  set logisticOperator (logisticOperator,) {
    this._id = logisticOperator._id;
    this.name = logisticOperator.name;
    this.address = logisticOperator.address;
    this.published = logisticOperator.published;
    this.address = logisticOperator.address;
    this.corporate_name = logisticOperator.corporate_name;
    this.cnpj = logisticOperator.cnpj;
    this.inscricao_estadual = logisticOperator.inscricao_estadual;
    this.inscricao_municipal = logisticOperator.inscricao_municipal;
    this.tax_regime = logisticOperator.tax_regime;
    this.responsible = logisticOperator.responsible;
    this.phone = logisticOperator.phone;
    this.attachments = (logisticOperator.attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
          attachment.status === 'APPROVED'
            ? 'Aprovado'
            : attachment.status === 'DISAPPROVED'
              ? 'Reprovado'
              : 'Pendente',
        name: `${attachment.attachment_type.split('_',)[0]}.${attachment.key.split('.',)[1]}`,
      };
    },);
  }

  set stores (stores,) {
    this._stores = stores;
    if (this.stores)
    {this.stores.items =
        stores && stores.items && stores.items.length
          ? stores.items.map((store,) => new Store(store,),)
          : [];}
  }

  set drivers (drivers,) {
    this._drivers = drivers;
    if (this.drivers)
    {this.drivers.items =
        drivers && drivers.items && drivers.items.length
          ? drivers.items.map((driver,) => new Driver(driver,),)
          : [];}
  }

  get stores () {
    return this._stores;
  }

  get drivers () {
    return this._drivers;
  }

  get toPost () {
    const newResponsible = { ...this.responsible, };
    newResponsible.phone = format.cleanPhone(newResponsible.phone,);
    return {
      address: {
        ...this.address,
        zipcode: format.cleanSymbols(this.address.zipcode,),
      },
      cnpj: format.cleanSymbols(this.cnpj,),
      corporate_name: this.corporate_name,
      name: this.name,
      responsible: newResponsible,
      tax_regime: this.tax_regime,
      inscricao_estadual: this.inscricao_estadual,
      inscricao_municipal: this.inscricao_municipal,
      attachments: this.attachments.map((attachment,) => {
        return {
          attachment_type: attachment.attachment_type,
          bucket: attachment.bucket,
          key: attachment.key,
          region: attachment.region,
        };
      },),
      franchise_id: VueX.getters['user/currentFranchise'],
    };
  }
}
